import React from "react";
import "./style.scss";

interface ItemProps {
    children?: any;
    label?: any;
    has_errors?: string;
    width?: string | number;
    disabled?: boolean;
}

const Item = (props: ItemProps) => {
    return (
        <div
            className="vapor-form_group"
            style={{ width: props.width || "inherit" }}
        >
            <div
                className={
                    "vapor-form_group-label" +
                    (props?.disabled ? " disabled" : "")
                }
            >
                {props.label || <>&nbsp;</>}
            </div>
            <div className="vapor-form_group-children">{props.children}</div>
            <div className="vapor-form_group-has_errors">
                {props.has_errors || <>&nbsp;</>}
            </div>
        </div>
    );
};

export default Item;
